import { useEffect, useState } from "react";
import { useProductData } from "@/zustand/productStore";
import { useTemplateStore } from "@/zustand/templateStore.js";
import ProductsList from "@/components/ProductPackages/ProductsList";
import Skeleton from "@/components/ProductPackages/Skeleton";
import s from "@/components/ProductPackages/ProductPackages.module.scss";
import { cn } from "@/utils/classNames.js";

const productsHeading = window.post_template?.checkout_v6_products?.tr_checkout_v6_products_heading;

const ProductPackages = () => {
  const [initialLoad, setIntialLoad] = useState(true);
  const productsData = useProductData();
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  useEffect(() => {
    const element = document.getElementById(`productCard-${1}`);
    if (!element || initialLoad) return;
    setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio < 1) {
              element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          });
        },
        {
          threshold: [0, 1],
        }
      );
      observer.observe(element);
      setTimeout(() => {
        return observer.disconnect();
      }, 310);
    }, 300);
  }, []);

  return (
    <>
      <div
        data-testid="products-label"
        className={cn(s.productPackages__heading, isEnhancedContrast && s.enhancedContrast)}
        id="products"
      >
        {productsHeading}
      </div>
      <div className={s.productPackages__wrapper}>
        {productsData?.products ? (
          <ProductsList bundles={productsData?.show_bundle_design} pickerV2={productsData?.show_product_picker_v2} />
        ) : (
          <Skeleton />
        )}
      </div>
    </>
  );
};

export default ProductPackages;
